import { Component, OnInit } from '@angular/core';
import { LayoutService } from 'app/shared/services/layout.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public layoutConf: any;

  constructor(
    private layout: LayoutService,
  ) { }

  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;
  }

}
